<template>
  <div class="container" >
    <!--UPLOAD-->
     <div v-if="isUpdating" class="fa-3x text-center">
        <i class="fas fa-spinner fa-spin"></i>
    </div>
    <h1>Upload District Boundary Files</h1>
    <div v-if="isInitial || isSaving">
    <input v-model="source" type="text" class="form-control" placeholder="Source">
    <br />
    <input v-model="notes" type="text" class="form-control" placeholder="Notes (Optional)">
    <br />
    <input v-model="start_date" type="text" class="form-control" placeholder="Start Date (Required)">
    <br />
    <input v-model="end_date" type="text" class="form-control" placeholder="End Date (Optional)">
    <br />
    </div>
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <div class="dropbox">
        <input
          type="file"
          multiple
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept=".kml,.kmz,.shp,.geojson"
          class="input-file"
        />
        <p v-if="isInitial">
          Drag your file(s) here to begin<br />
          or click to browse
        </p>
        <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
      </div>
    </form>
     <div>
      <p></p>
      <p v-if="isSuccess">
        Assign district numbers to the uploaded files below and click 'Submit' to update the district_boundaries table
      </p>
     
      <p> 
      <button v-if="isSuccess" class="btn btn-default submit-btn uploadsubmit" @click="submitUpdates">
        Submit
      </button>
      </p>
    
     <p>
      <button v-if="isFinished" class="btn btn-default submit-btn uploadsubmit" @click="reset">
       Reset
      </button>
      </p>
     
    </div>
     <div v-if="isSuccess || isFinished || isUpdating">
       <p>
         <hot-table :data="uploadedFiles" :settings="settings" ref="hot" :colHeaders="['District', 'File Name', 'Upload Results']"></hot-table>
         </p>
    </div>
         
  </div>
</template>
<script>
import { HotTable } from "@handsontable/vue";
import { registerAllModules } from 'handsontable/registry';
registerAllModules();

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_UPDATING = 3,
  STATUS_FAILED = 4,
  STATUS_FINISHED = 5;

export default {
  name: "UploadDistrictBoundaries",

  data() {
    return {
      source: null,
      notes: null,
      start_date: null,
      end_date: null,
      uploadedFiles: [],
      resultsArray: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "maps",
      settings: {
        preventOverflow: "horizontal",
        filters: true,
        comments: true,
        licenseKey: "non-commercial-and-evaluation",
        manualRowMove: true,
        manualColumnMove: true,
        exportFile: true,
        manualRowResize: true,
        manualColumnResize: true,
        autoRowSize: true,
        manualColumnFreeze: true,
        bindRowsWithHeaders: true,
        renderAllRows: true,
        contextMenu: ["freeze_column", "unfreeze_column"]
      }
    };
  },
  components: {
    HotTable
  },

  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isUpdating(){
      return this.currentStatus === STATUS_UPDATING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isFinished() {
      return this.currentStatus === STATUS_FINISHED;
    }
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.resultsArray = [];
      this.source = null;
      this.notes = null;
      this.start_date = null;
      this.end_date = null;
    },
    async save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      let file;
       for (let value of formData.values()) {
        file = value;

        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/districts/upload`;

        let response1 = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify({
            fileName: file.name
          })
        });
        response1 = await response1.json();
       
        if (!response1.data || !response1.success) {
          alert("response1" + response1.message);
          this.uploadError = response1.message;
          this.currentStatus = STATUS_INITIAL;
          continue;
        }
        let uploadData = new FormData();
        for (var key in response1.data) {
          uploadData.append(key, "" + response1.data[key]);
        }
        uploadData.append("file", file); 

        let response2 = await fetch("https://ballotpedia-api4.s3.amazonaws.com/", {
          method: "POST",
          headers: { ACL: "public-read" },
          body: uploadData
        });
        if (!response2.ok) {
          alert(response2.statusText);
          this.uploadError = response2.statusText;
          this.currentStatus = STATUS_INITIAL;
        } else {
          let districtFileObject = {
            name: " ",
            file: file.name,
            result: ""
          };
          this.uploadedFiles.push(districtFileObject);
        }
      }
     this.uploadedFiles.sort((a, b) => (a.file > b.file) ? 1 : -1);
     if (this.uploadedFiles.length > 0){
        this.currentStatus = STATUS_SUCCESS;
     }
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData);
    },
    async submitUpdates() {
       this.currentStatus = STATUS_UPDATING;
      // call the endpoint to update the district boundaries
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/districts/process`;
      let thisbody;
      let row = 0;
       
      for await (const item of this.$refs.hot.hotInstance.getSourceData()) {
        row++;
        thisbody = {
          district: item.name,
          fileName: item.file,
          source: this.source ? this.source : null,
          notes: this.notes ? this.notes : null,
          start_date: this.start_date ? this.start_date : null,
          end_date: this.end_date ? this.end_date : null
        };
        let response3 = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(thisbody)
        });
        response3 = await response3.json();
        let testmsg ='';
        if (response3.message){
            testmsg = JSON.parse(response3.message).message;
        }
        let results = {
          row: row,
          result: `${response3.success}  ${testmsg}`
        };
        this.resultsArray.push(results);

      }
      
      for (const item of this.resultsArray) {
          this.$refs.hot.hotInstance.setDataAtCell(item.row - 1, 2, `success: ${item.result}`);
      }
      this.currentStatus = STATUS_FINISHED;
    }
  },
  mounted() {
    this.reset();
  }
};
</script>
<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
  border-radius: 5px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}
.modal-container .btn {
  margin: 0 auto;
}
.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}
.modal-body {
  margin: 20px 0;
  white-space: pre-line;
}
.modal-default-button {
  margin: 0 auto;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.uploadsubmit{
  width: 100px;
}
</style>
 